import axios from '../../utils/ajax';
import Global from '../../utils/global';

//查询配置
export const getConfigApi = () => {
    return axios.ajax(Global.getBaseUrl() + '/log/analysis/load', 'get', {});
};

//添加配置
export const addConfigApi = (params) => {
    return axios.ajax(Global.getBaseUrl() + '/log/analysis', 'post', params);
};

//修改配置
export const editConfigApi = (params) => {
    return axios.ajax(Global.getBaseUrl() + '/log/analysis', 'put', params);
};

//删除配置
export const deleteConfigApi = (params) => {
    return axios.ajax(Global.getBaseUrl() + '/log/analysis/' + params.id, 'delete', params);
};

// 获取非常规业务
export const getUnconventionalBusinessApi = (params) => {
    return axios.ajax(Global.getBaseUrl() + '/log/analysis/init', 'get', params);
};
